import _ from 'lodash'
import empty from './empty'
import axios from '@/utils/api'

import {
  SET_CONVERSAS_PROCESSO,
  SET_CONVERSAS_TIPO,
  SET_CONVERSA_MENSAGENS,
  SET_RESPOSTA_CONTEUDO,
  SET_CONVERSA_RESPOSTA,
  ADD_ANEXO,
  REMOVE_ANEXO,
  SET_RESPOSTA_ANEXO,
  SET_TIPO_ANEXOS_PENDENTES_CONVERSA
} from '../../mutation-types'

const state = empty.state.emptyConversas()

const getters = {
  tipo: state => state.tipo,
  conversasProcesso: state => state.conversasProcesso,
  mensagens: state => state.mensagens,
  resposta: state => state.resposta,
  tipoDocumento: state => state.tipoDocumentosAnexo
}

const mutations = {
  [SET_CONVERSAS_PROCESSO] (state, conversas) {
    state.conversasProcesso.totalConversas = conversas.length
    state.conversasProcesso.list = conversas
  },
  [SET_CONVERSAS_TIPO] (state, tipo) {
    state.tipo = tipo
  },
  [SET_CONVERSA_MENSAGENS] (state, mensagens) {
    state.mensagens = mensagens
    state.mensagens.idxUltimaMensagem = mensagens.mensagemList.length - 1
  },
  [SET_CONVERSA_RESPOSTA] (state, params) {
    state.resposta.conversa.id = params.idConversa
    state.resposta.remetente.id = params.idPessoa
    state.resposta.destinatario.id = state.mensagens.mensagemList[0].remetente.id
  },
  [ADD_ANEXO] (state, payload) {
    state.resposta.anexoList.push(payload)
  },

  [REMOVE_ANEXO] (state, payload) {
    state.resposta.anexoList.splice(_.findIndex(state.resposta.anexoList,
      anexo => anexo.key === payload.key), 1)
  },
  [SET_RESPOSTA_CONTEUDO] (state, conteudo) {
    state.resposta.conteudo = conteudo
  },

  [SET_RESPOSTA_ANEXO] (state, anexoList) {
    state.resposta.anexoList = anexoList
  },

  [SET_TIPO_ANEXOS_PENDENTES_CONVERSA] (state, tipos) {
    state.tipoDocumentosAnexo = tipos
  }
}

const actions = {
  async findConversasProcesso ({ commit }, data) {
    const conversas = await axios({
      method: 'POST',
      url: 'conversa/findByProcesso',
      data: data
    })
    commit('SET_CONVERSAS_PROCESSO', conversas)
  },

  async findConversasByDespacho ({ commit }, idDespacho) {
    const conversas = await axios({
      method: 'GET',
      url: 'conversa/findByDespacho/' + idDespacho
    })
    return conversas
  },

  async findSolicitacoesInformacaoByDespacho ({ commit }, idDespacho) {
    const solicitacoesInformacao = await axios({
      method: 'GET',
      url: 'solicitarInformacao/findByDespacho/' + idDespacho
    })
    return solicitacoesInformacao
  },

  async findProtestoByDespacho ({ commit }, idDespacho) {
    return axios({
      method: 'GET',
      url: 'protesto/findByDespacho/' + idDespacho
    })
  },

  async read ({ commit }, params) {
    const mensagens = await axios({
      method: 'GET',
      url: `conversa/${params.idConversa}/leitura`
    })
    commit('SET_CONVERSA_MENSAGENS', mensagens)
    commit('SET_CONVERSA_RESPOSTA', params)
  },

  async sendMensagensProcesso ({ commit, state }, resposta) {
    const conversa = {
      ...state.mensagens,
      mensagemList: [{ ...resposta }]
    }

    await axios({
      method: 'post',
      url: 'conversa/mensagem',
      data: conversa
    })
  },

  async clearMensagensProcesso ({ commit }) {
    commit('SET_CONVERSAS_PROCESSO', empty.state.emptyConversas().conversasProcesso)
  },

  async clearResposta ({ commit }) {
    commit('SET_RESPOSTA_CONTEUDO', null)
    commit('SET_RESPOSTA_ANEXO', [])
  },

  async baixarDocumento ({ commit }, payload) {
    await axios({
      method: 'GET',
      url: `mensagem/anexo/${payload.id}`,
      responseType: 'blob'
    })
  },

  async getConversasByFilter ({ commit }, parametros) {
    const conversas = await axios({
      method: 'POST',
      url: 'conversa/ouvidoria/filtro',
      data: parametros
    })

    return conversas
  },

  async getConversasManutencao ({ commit }, parametros) {
    const conversas = await axios({
      method: 'POST',
      url: 'conversa/manutencao/findConversas',
      data: parametros
    })

    return conversas
  },

  async findById ({ commit }, idConversa) {
    const conversa = await axios({
      method: 'GET',
      url: 'conversa/' + idConversa + '/mensagens'
    })
    return conversa
  },

  async getAssuntosOuvidoria ({ commit }) {
    const assuntos = await axios({
      method: 'GET',
      url: 'conversa/ouvidoria/assuntos'
    })
    return assuntos
  },

  async getStatusOuvidoria ({ commit }) {
    const status = await axios({
      method: 'GET',
      url: 'conversa/ouvidoria/status'
    })
    return status
  }

}

export default {
  namespaced: true,
  mutations,
  actions,
  getters,
  state
}



// WEBPACK FOOTER //
// ./src/store/modules/centralInteressado/conversas.js